<div class="display-flex flex-column grid-gap-4">
  <div class="display-flex align-items-center justify-content-space-between question-item">
    <div class="display-flex align-items-center grid-gap-4">
      <div class="display-flex align-items-center grid-gap-4">
        <div class="display-flex align-items-center justify-content-center">
          <ng-content select="[dragHandle]"></ng-content>
        </div>

        <div class="display-flex align-items-center grid-gap-8">
          <ng-container *ngIf="questionItem?.customFieldBinding || isChoosingCustomFieldType; else fieldTypeTemplate">
            <div
              *ngIf="chooseCustomFieldIcon(questionItem) | async as icon"
              [ngStyle]="{ cursor: isEditingSetting ? 'default' : 'pointer' }"
              (click)="toggleSetting(true)"
              class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field">
              <app-icon
                *ngIf="isChoosingCustomFieldType"
                [svg]="EIcon.PAGE_INFO"
                [iconWidth]="14"
                [iconHeight]="14"
                [iconColor]="EColorPalette.cGreen"></app-icon>
              <mat-icon
                *ngIf="!isChoosingCustomFieldType"
                class="display-flex align-items-center justify-content-center">
                {{ icon }}
              </mat-icon>
            </div>
          </ng-container>

          <ng-template #fieldTypeTemplate>
            <ng-container *ngIf="questionItem?.type === 'boolean'; else nonBooleanTemplate">
              <div
                class="display-flex align-items-center grid-gap-4"
                [ngStyle]="{ cursor: isEditingSetting ? 'default' : 'pointer' }"
                (click)="toggleSetting(true)">
                <button
                  aria-label="thumb-up-button"
                  type="button"
                  [matTooltipClass]="'multi-line-tooltip'"
                  [matTooltip]="
                    'Default answer: yes\n\nNOTE: this question will only appear in report if \'no\' is chosen by mobile user'
                  "
                  matTooltipShowDelay="500"
                  class="thumb-icon"
                  mat-icon-button
                  (click)="toggleDefaultValue(true)">
                  <app-icon [svg]="questionItem.defaultValue === true ? EIcon.YES_ACTIVE : EIcon.YES"></app-icon>
                </button>
                <button
                  aria-label="thumb-down-button"
                  type="button"
                  [matTooltipClass]="'multi-line-tooltip'"
                  [matTooltip]="
                    'Default answer: no.\n\nNOTE: this question will only appear in report if \'yes\' is chosen by mobile user'
                  "
                  matTooltipShowDelay="500"
                  class="thumb-icon"
                  mat-icon-button
                  (click)="toggleDefaultValue(false)">
                  <app-icon [svg]="questionItem.defaultValue === false ? EIcon.NO_ACTIVE : EIcon.NO"></app-icon>
                </button>
              </div>
            </ng-container>
          </ng-template>

          <ng-template #nonBooleanTemplate>
            <div
              class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field"
              [ngStyle]="{ cursor: isEditingSetting ? 'default' : 'pointer' }"
              (click)="toggleSetting(true)">
              <mat-icon
                class="display-flex align-items-center justify-content-center"
                *ngIf="questionItem?.type === 'text'">
                title
              </mat-icon>
              <mat-icon
                class="display-flex align-items-center justify-content-center"
                *ngIf="questionItem?.type === 'int'">
                numbers
              </mat-icon>
              <app-icon
                *ngIf="questionItem?.type === 'number'"
                [svg]="EIcon.DOT_ZERO"
                [iconWidth]="12"
                [iconHeight]="12"
                [iconColor]="EColorPalette.cGreen"></app-icon>
              <mat-icon
                class="display-flex align-items-center justify-content-center"
                *ngIf="questionItem?.type === 'money'">
                attach_money
              </mat-icon>
              <mat-icon
                class="display-flex align-items-center justify-content-center"
                *ngIf="questionItem?.type === 'user'">
                person
              </mat-icon>
              <app-icon
                *ngIf="questionItem?.type === 'date'"
                [svg]="EIcon.CALENDAR_MONTH"
                [iconWidth]="18"
                [iconHeight]="18"
                [iconColor]="EColorPalette.cGreen"></app-icon>
              <app-icon
                *ngIf="questionItem?.type == 'dateTime'"
                [svg]="EIcon.CALENDAR_CLOCK"
                [iconWidth]="18"
                [iconHeight]="18"
                [iconColor]="EColorPalette.cGreen"></app-icon>
              <app-icon
                *ngIf="questionItem?.type === 'dropdown'"
                [svg]="EIcon.ARROW_DROP_DOWN_CIRCLE"
                [iconWidth]="18"
                [iconHeight]="18"
                [iconColor]="EColorPalette.cGreen"></app-icon>
              <mat-icon
                class="display-flex align-items-center justify-content-center"
                *ngIf="questionItem?.type === 'checkList'">
                done_all
              </mat-icon>
              <app-icon
                *ngIf="questionItem?.type === 'radiolist'"
                [svg]="EIcon.RADIO_BUTTON"
                [iconWidth]="18"
                [iconHeight]="18"
                [iconColor]="EColorPalette.cGreen"></app-icon>
            </div>
          </ng-template>

          <div *ngIf="!isChoosingCustomFieldType" class="display-flex align-items-center grid-gap-8">
            <div class="display-flex align-items-center" (click)="toggleSetting(true)">
              <input
                name="questionTitle-{{ questionItem?.guid }}"
                id="questionTitle-{{ questionItem?.guid }}"
                aria-label="question-input"
                #inputElement
                class="input"
                [value]="questionItem.title"
                (blur)="questionChange($event)"
                (keydown)="keyPressed($event)"
                [maxLength]="70"
                (input)="updateWidth($event)"
                [style.width]="questionWidth"
                [placeholder]="placeholder" />
              <span *ngIf="questionItem?.isRequired !== false" class="required">*</span>
            </div>

            <button
              class="dropdown-options-button"
              mat-button
              *ngIf="
                !isChoosingCustomFieldType && !questionItem?.customFieldBinding && questionItem?.type === 'dropdown'
              "
              (click)="openDropdownOptionsEditor(questionItem)">
              {{ questionItem?.options?.length > 0 ? 'Edit' : 'Add' }} options
            </button>

            <div *ngIf="currentDefaultLabel && !isDefaultTempateType" class="question-divider"></div>

            <span
              *ngIf="currentDefaultLabel && !isDefaultTempateType"
              class="question-short-data"
              (click)="toggleSetting(true)">
              {{ currentVarianceLabel ?? 'Default' }}: {{ currentDefaultLabel }}
              <span
                *ngIf="currentDefaultLabel && currentDefaultLabelExtraCount && currentDefaultLabelExtraCount > 0"
                class="question-short-data question-short-data-extra-count">
                +{{ currentDefaultLabelExtraCount }}
              </span>
            </span>
          </div>
        </div>
      </div>

      <span #questionTitleElement class="title-hidden"></span>

      <ng-container *ngIf="isChoosingCustomFieldType">
        <app-radio-button-dropdown
          class="select-custom-field-dropdown-width thin-control"
          [items]="customFieldTypeOptions"
          [(ngModel)]="selectedCustomFieldId"
          (ngModelChange)="onCustomFieldTypeChange($event)"
          [isSmallFont]="true"
          [optionCss]="'inspection-format-option'"
          [allowClear]="false"
          [allowSearch]="customFieldTypeOptions?.length > 7"
          attrPlaceholder="Select a custom field"
          [attrAppendTo]="'body'"></app-radio-button-dropdown>
      </ng-container>

      <div class="actions" *ngIf="isChoosingCustomFieldType && questionItem?.customFieldBinding">
        <button
          aria-label="cancel-button"
          type="button"
          class="action-button action-button-cancel"
          mat-icon-button
          [matTooltip]="'Cancel'"
          matTooltipShowDelay="500"
          (click)="cancelCustomFieldSelection()">
          <mat-icon class="display-flex align-items-center justify-content-center">reply</mat-icon>
        </button>
      </div>

      <div class="actions">
        <button
          aria-label="delete-button"
          type="button"
          class="action-button"
          mat-icon-button
          [matTooltip]="'Delete question'"
          matTooltipShowDelay="500"
          (click)="removeClick()">
          <app-icon [iconWidth]="16" [iconHeight]="16" [svg]="EIcon.MAT_DELETE_FOREVER"></app-icon>
        </button>
      </div>
    </div>

    <div class="display-flex align-items-center grid-gap-8" (click)="toggleSetting(true)">
      <div
        *ngIf="questionItem?.type === 'radiolist'"
        class="optional-content-settings-container small-custom-toggle display-flex align-items-center grid-gap-4"
        [formGroup]="questionForm">
        <span class="display-flex align-items-center grid-gap-6">
          <a
            class="menu-trigger-text menu-trigger-text-orientation display-flex align-items-center grid-gap-4"
            [matMenuTriggerFor]="orientationMenu"
            #orientationTrigger="matMenuTrigger"
            (menuOpened)="onOrientationMenuOpened()"
            (menuClosed)="onOrientationMenuClosed()">
            {{
              questionForm.get('orientation')?.value === RadioListOrientation.Horizontal ? 'Horizontally' : 'Vertically'
            }}
            <app-icon
              [iconColor]="EColorPalette.cGray4"
              [svg]="orientationTrigger?.menuOpen ? EIcon.ANGLE_UP : EIcon.ANGLE_DOWN"
              [iconWidth]="6"
              [iconHeight]="6"></app-icon>
          </a>
        </span>
      </div>

      <button
        *ngIf="questionItem?.type === 'checkList' || questionItem?.type === 'radiolist'"
        aria-label="require-photo-button"
        type="button"
        class="action-button action-button-show"
        mat-icon-button
        [matTooltip]="'Require photo'"
        matTooltipShowDelay="500"
        (click)="setPhotoRequiredForAll()">
        <app-icon
          [svg]="EIcon.REQUIRE_PHOTO"
          [iconColor]="questionItem.photoRequiresForAllitems ? EColorPalette.cGreen : EColorPalette.cGray2"
          [iconWidth]="20"
          [iconHeight]="20"></app-icon>
      </button>

      <button
        *ngIf="questionItem?.type === 'checkList' || questionItem?.type === 'radiolist'"
        aria-label="require-comments-button"
        type="button"
        class="action-button action-button-show"
        mat-icon-button
        [matTooltip]="'Require comments'"
        matTooltipShowDelay="500"
        (click)="setCommentsRequiredForAll()">
        <app-icon
          [svg]="EIcon.REQUIRE_COMMENT"
          [iconColor]="questionItem.commentsRequiresForAllitems ? EColorPalette.cGreen : EColorPalette.cGray2"
          [iconWidth]="20"
          [iconHeight]="20"></app-icon>
      </button>

      <div class="display-flex align-items-center justify-content-center">
        <button
          *ngIf="!isChoosingCustomFieldType"
          aria-label="toggle-button"
          class="toggle-button"
          type="button"
          mat-icon-button
          [matTooltip]="isEditingSetting ? 'Collapse settings' : 'Expand settings'"
          (click)="toggleSetting(); $event.stopPropagation()">
          <app-icon
            [svg]="isEditingSetting ? EIcon.ANGLE_UP : EIcon.ANGLE_DOWN"
            [iconWidth]="8"
            [iconHeight]="8"
            [iconColor]="EColorPalette.cGray5"></app-icon>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isEditingSetting && !questionItem?.customFieldBinding" class="optional-content-container">
    <div class="display-flex flex-column grid-gap-4">
      <div class="optional-content-settings-container display-flex align-items-center grid-gap-4">
        <span class="optional-content-settings-container-text" (click)="toggleCustomFieldTypeChange()">
          Type: {{ typeLabelMap[questionItem?.type] }}
        </span>
        <div
          mat-icon-button
          class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle thumb-icon-custom-field-circle-no-background"
          [matTooltip]="'Choose custom field type'"
          (click)="toggleCustomFieldTypeChange()">
          <app-icon
            [svg]="isChoosingFieldType ? EIcon.ANGLE_LEFT : EIcon.ANGLE_RIGHT"
            [iconWidth]="8"
            [iconHeight]="8"
            [iconColor]="EColorPalette.cGray5"></app-icon>
        </div>
        <div
          *ngIf="isChoosingFieldType"
          class="optional-content-settings-container display-flex align-items-center grid-gap-8">
          <div
            mat-icon-button
            class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen':
                !questionItem?.customFieldBinding && questionItem?.type === 'boolean'
            }"
            [matTooltip]="'Boolean'"
            (click)="onFieldTypeSelect('boolean')">
            <app-icon
              [svg]="EIcon.THUMB_UP_DOWN"
              [iconWidth]="14"
              [iconHeight]="14"
              [iconColor]="
                !questionItem?.customFieldBinding && questionItem?.type === 'boolean'
                  ? EColorPalette.cGreen
                  : EColorPalette.cGray5
              "></app-icon>
          </div>
          <div
            mat-icon-button
            class="thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen':
                !questionItem?.customFieldBinding && questionItem?.type === 'text'
            }"
            [matTooltip]="'Text'"
            (click)="onFieldTypeSelect('text')">
            <mat-icon class="display-flex align-items-center justify-content-center">title</mat-icon>
          </div>
          <div
            mat-icon-button
            class="thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen': !questionItem?.customFieldBinding && questionItem?.type === 'int'
            }"
            [matTooltip]="'Integer'"
            (click)="onFieldTypeSelect('int')">
            <mat-icon class="display-flex align-items-center justify-content-center">numbers</mat-icon>
          </div>
          <div
            mat-icon-button
            class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen':
                !questionItem?.customFieldBinding && questionItem?.type === 'number'
            }"
            [matTooltip]="'Decimal'"
            (click)="onFieldTypeSelect('number')">
            <app-icon
              [svg]="EIcon.DOT_ZERO"
              [iconWidth]="10"
              [iconHeight]="10"
              [iconColor]="
                !questionItem?.customFieldBinding && questionItem?.type === 'number'
                  ? EColorPalette.cGreen
                  : EColorPalette.cGray5
              "></app-icon>
          </div>
          <div
            mat-icon-button
            class="thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen':
                !questionItem?.customFieldBinding && questionItem?.type === 'money'
            }"
            [matTooltip]="'Amount'"
            (click)="onFieldTypeSelect('money')">
            <mat-icon class="display-flex align-items-center justify-content-center">attach_money</mat-icon>
          </div>
          <div
            mat-icon-button
            class="thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle thumb-icon-custom-field-circle-disabled"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen':
                !questionItem?.customFieldBinding && questionItem?.type === 'user'
            }"
            [matTooltip]="'User - coming soon'">
            <!-- (click)="onFieldTypeSelect(CustomFieldType.User)" -->
            <mat-icon class="display-flex align-items-center justify-content-center">person</mat-icon>
          </div>
          <div
            mat-icon-button
            class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen':
                !questionItem?.customFieldBinding && questionItem?.type === 'date'
            }"
            [matTooltip]="'Date'"
            (click)="onFieldTypeSelect('date')">
            <app-icon
              [svg]="EIcon.CALENDAR_MONTH"
              [iconWidth]="14"
              [iconHeight]="14"
              [iconColor]="
                !questionItem?.customFieldBinding && questionItem?.type === 'date'
                  ? EColorPalette.cGreen
                  : EColorPalette.cGray5
              "></app-icon>
          </div>
          <div
            mat-icon-button
            class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen':
                !questionItem?.customFieldBinding && questionItem?.type === 'dateTime'
            }"
            [matTooltip]="'Date & Time'"
            (click)="onFieldTypeSelect('dateTime')">
            <app-icon
              [svg]="EIcon.CALENDAR_CLOCK"
              [iconWidth]="14"
              [iconHeight]="14"
              [iconColor]="
                !questionItem?.customFieldBinding && questionItem?.type === 'dateTime'
                  ? EColorPalette.cGreen
                  : EColorPalette.cGray5
              "></app-icon>
          </div>
          <div
            mat-icon-button
            class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen':
                !questionItem?.customFieldBinding && questionItem?.type === 'dropdown'
            }"
            [matTooltip]="'Drop-down list'"
            (click)="onFieldTypeSelect('dropdown')">
            <app-icon
              [svg]="EIcon.ARROW_DROP_DOWN_CIRCLE"
              [iconWidth]="14"
              [iconHeight]="14"
              [iconColor]="
                !questionItem?.customFieldBinding && questionItem?.type === 'dropdown'
                  ? EColorPalette.cGreen
                  : EColorPalette.cGray5
              "></app-icon>
          </div>
          <div
            mat-icon-button
            class="thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen':
                !questionItem?.customFieldBinding && questionItem?.type === 'checkList'
            }"
            [matTooltip]="'Checklist'"
            (click)="onFieldTypeSelect('checkList')">
            <mat-icon class="display-flex align-items-center justify-content-center">done_all</mat-icon>
          </div>
          <div
            mat-icon-button
            class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen':
                !questionItem?.customFieldBinding && questionItem?.type === 'radiolist'
            }"
            [matTooltip]="'Radiolist'"
            (click)="onFieldTypeSelect('radiolist')">
            <app-icon
              [svg]="EIcon.RADIO_BUTTON"
              [iconWidth]="14"
              [iconHeight]="14"
              [iconColor]="
                !questionItem?.customFieldBinding && questionItem?.type === 'radiolist'
                  ? EColorPalette.cGreen
                  : EColorPalette.cGray5
              "></app-icon>
          </div>
          <div
            mat-icon-button
            class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-custom-field thumb-icon-custom-field-circle"
            [ngClass]="{
              'thumb-icon-custom-field-circle-chosen': !!questionItem?.customFieldBinding
            }"
            [matTooltip]="'Custom field'"
            (click)="onFieldTypeSelect('customField')">
            <app-icon
              [svg]="EIcon.PAGE_INFO"
              [iconWidth]="14"
              [iconHeight]="14"
              [iconColor]="!!questionItem?.customFieldBinding ? EColorPalette.cGreen : EColorPalette.cGray5"></app-icon>
          </div>
        </div>
      </div>
      <div
        class="optional-content-settings-container small-custom-toggle display-flex align-items-center grid-gap-4"
        [formGroup]="questionForm">
        <span class="optional-content-settings-container-text">Required</span>
        <app-slide-toggle
          formControlName="isRequired"
          [containerCss]="'toggle-small'"
          [labelCss]="'body-small'"
          [disableRipple]="true"
          [activeBold]="false"></app-slide-toggle>
        <span *ngIf="questionItem?.type === 'checkList'" class="text-checklist-comment">
          (at least one checkbox should be selected)
        </span>
      </div>
      <ng-container
        *ngIf="!isDefaultTempateType && questionItem?.type !== 'checkList' && questionItem?.type !== 'radiolist'">
        <div class="optional-content-settings-container display-flex align-items-center grid-gap-10">
          <span class="display-flex align-items-center grid-gap-4">
            Default:
            <a
              class="menu-trigger-text display-flex align-items-center grid-gap-4"
              [matMenuTriggerFor]="defaultValueMenu"
              #menuTrigger="matMenuTrigger"
              (menuOpened)="onDefaultMenuOpened()"
              (menuClosed)="onDefaultMenuClosed()">
              {{ currentDefaultLabel ?? 'Not set' }}
              <app-icon
                [iconColor]="EColorPalette.cGray4"
                [svg]="menuTrigger?.menuOpen ? EIcon.ANGLE_UP : EIcon.ANGLE_DOWN"
                [iconWidth]="8"
                [iconHeight]="8"></app-icon>
            </a>
          </span>

          <span
            class="display-flex align-items-center grid-gap-4"
            *ngIf="questionItem?.defaultValue !== null && questionItem?.defaultValue !== undefined">
            Show as:
            <a
              class="menu-trigger-text display-flex align-items-center grid-gap-4"
              [matMenuTriggerFor]="displayModeMenu"
              #menuTrigger="matMenuTrigger"
              (menuOpened)="onVarianceMenuOpened()"
              (menuClosed)="onVarianceMenuClosed()">
              {{ currentVarianceLabel ?? 'Default' }}
              <app-icon
                [iconColor]="EColorPalette.cGray4"
                [svg]="menuTrigger?.menuOpen ? EIcon.ANGLE_UP : EIcon.ANGLE_DOWN"
                [iconWidth]="8"
                [iconHeight]="8"></app-icon>
            </a>
          </span>
        </div>
      </ng-container>

      <ng-container *ngIf="questionItem?.type === 'checkList'">
        <div class="display-flex flex-column grid-gap-4">
          <div
            class="checklist-container display-flex flex-column grid-gap-4"
            cdkDropList
            (cdkDropListDropped)="onDrop($event)">
            <div
              class="checklist-item display-flex align-items-center grid-gap-4"
              *ngFor="let option of questionItem?.options; let i = index"
              cdkDrag>
              <mat-icon
                [inline]="true"
                cdkDragHandle
                class="display-flex align-items-center justify-content-center drag-icon">
                drag_indicator
              </mat-icon>

              <div
                mat-icon-button
                class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-checklist"
                [ngClass]="{
                  'thumb-icon-checklist-chosen': (questionForm.value.photoRequiresOn ?? []).includes(option.value)
                }"
                [matTooltip]="'Require photo'"
                (click)="setPhotoRequired(option.value)">
                <app-icon
                  [svg]="EIcon.REQUIRE_PHOTO"
                  [iconColor]="
                    (questionForm.value.photoRequiresOn ?? []).includes(option.value)
                      ? EColorPalette.cGreen
                      : EColorPalette.cGray2
                  "
                  [iconWidth]="18"
                  [iconHeight]="18"></app-icon>
              </div>

              <div
                mat-icon-button
                class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-checklist"
                [ngClass]="{
                  'thumb-icon-checklist-chosen': (questionForm.value.commentsRequiresOn ?? []).includes(option.value)
                }"
                [matTooltip]="'Require comments'"
                (click)="setCommentsRequired(option.value)">
                <app-icon
                  [svg]="EIcon.REQUIRE_COMMENT"
                  [iconColor]="
                    (questionForm.value.commentsRequiresOn ?? []).includes(option.value)
                      ? EColorPalette.cGreen
                      : EColorPalette.cGray2
                  "
                  [iconWidth]="18"
                  [iconHeight]="18"></app-icon>
              </div>

              <div class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-checklist">
                <mat-checkbox
                  class="mat-checkbox-small-no-label"
                  color="primary"
                  [checked]="(questionForm.value.defaultValue ?? []).includes(option.value)"
                  (change)="toggleDefaultOption(option.value)"></mat-checkbox>
              </div>

              <input
                class="input checklist-label-input"
                [value]="option.label"
                (blur)="updateOptionLabel(i, $event)"
                (keydown.enter)="
                  updateOptionLabel(i, $event); addOptionAfter(i); $event.preventDefault(); $event.stopPropagation()
                "
                [maxLength]="50"
                (input)="updateOptionWidth($event, i)"
                [placeholder]="optionPlaceholder"
                [style.width]="optionWidths[i] ?? 'auto'" />
              <span #optionLabelElement class="title-hidden"></span>

              <button
                aria-label="delete-option-button"
                type="button"
                class="action-button"
                mat-icon-button
                [matTooltip]="'Delete option'"
                matTooltipShowDelay="500"
                (click)="removeOption(i)">
                <app-icon [iconWidth]="16" [iconHeight]="16" [svg]="EIcon.MAT_DELETE_FOREVER"></app-icon>
              </button>

              <ng-template cdkDragPlaceholder>
                <div class="question-placeholder"></div>
              </ng-template>
            </div>

            <button
              class="display-flex align-items-center justify-content-center options-button options-button-add"
              (click)="addOption()"
              mat-button>
              <span class="display-flex align-items-center justify-content-center grid-gap-4 add-button">
                <app-icon
                  [iconWidth]="20"
                  [iconHeight]="20"
                  [iconColor]="EColorPalette.cGray7"
                  [svg]="EIcon.PLUS"></app-icon>
                <span>ITEM</span>
              </span>
            </button>
          </div>

          <span
            class="display-flex align-items-center grid-gap-4"
            *ngIf="
              !isDefaultTempateType &&
              questionItem?.defaultValue &&
              questionItem?.defaultValue !== null &&
              questionItem?.defaultValue !== undefined
            ">
            Show as:
            <a
              class="menu-trigger-text display-flex align-items-center grid-gap-4"
              [matMenuTriggerFor]="displayModeMenu"
              #menuTrigger="matMenuTrigger"
              (menuOpened)="onVarianceMenuOpened()"
              (menuClosed)="onVarianceMenuClosed()">
              {{ currentVarianceLabel ?? 'Default' }}
              <app-icon
                [iconColor]="EColorPalette.cGray4"
                [svg]="menuTrigger?.menuOpen ? EIcon.ANGLE_UP : EIcon.ANGLE_DOWN"
                [iconWidth]="8"
                [iconHeight]="8"></app-icon>
            </a>
          </span>
        </div>
      </ng-container>

      <ng-container *ngIf="questionItem?.type === 'radiolist'">
        <div class="display-flex flex-column grid-gap-4" [formGroup]="questionForm">
          <div
            class="radiolist-container display-flex grid-gap-4"
            [ngClass]="{ 'flex-column': questionForm.get('orientation')?.value !== RadioListOrientation.Horizontal }"
            cdkDropList
            (cdkDropListDropped)="onDrop($event)"
            [cdkDropListOrientation]="
              questionForm.get('orientation')?.value === RadioListOrientation.Horizontal ? 'horizontal' : 'vertical'
            ">
            <div
              class="radiolist-item display-flex align-items-center grid-gap-4"
              [ngClass]="{
                'align-items-end radiolist-item-horizontal':
                  questionForm.get('orientation')?.value === RadioListOrientation.Horizontal
              }"
              *ngFor="let option of questionItem?.options; let i = index"
              cdkDrag>
              <mat-icon
                [inline]="true"
                cdkDragHandle
                class="display-flex align-items-center justify-content-center drag-icon">
                drag_indicator
              </mat-icon>

              <div
                class="display-flex"
                [ngClass]="{
                  'flex-column': questionForm.get('orientation')?.value === RadioListOrientation.Horizontal
                }">
                <div class="display-flex">
                  <div
                    *ngIf="questionForm.get('orientation')?.value !== RadioListOrientation.Horizontal"
                    class="custom-input-container display-flex align-items-center justify-content-center">
                    <input type="radio" class="custom-input" [value]="option.value" formControlName="defaultValue" />
                  </div>

                  <div
                    mat-icon-button
                    class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-checklist"
                    [ngClass]="{
                      'thumb-icon-checklist-chosen': (questionForm.value.photoRequiresOn ?? []).includes(option.value)
                    }"
                    [matTooltip]="'Require photo'"
                    (click)="setPhotoRequired(option.value)">
                    <app-icon
                      [svg]="EIcon.REQUIRE_PHOTO"
                      [iconColor]="
                        (questionForm.value.photoRequiresOn ?? []).includes(option.value)
                          ? EColorPalette.cGreen
                          : EColorPalette.cGray2
                      "
                      [iconWidth]="18"
                      [iconHeight]="18"></app-icon>
                  </div>

                  <div
                    mat-icon-button
                    class="display-flex align-items-center justify-content-center thumb-icon thumb-icon-checklist"
                    [ngClass]="{
                      'thumb-icon-checklist-chosen': (questionForm.value.commentsRequiresOn ?? []).includes(
                        option.value
                      )
                    }"
                    [matTooltip]="'Require comments'"
                    (click)="setCommentsRequired(option.value)">
                    <app-icon
                      [svg]="EIcon.REQUIRE_COMMENT"
                      [iconColor]="
                        (questionForm.value.commentsRequiresOn ?? []).includes(option.value)
                          ? EColorPalette.cGreen
                          : EColorPalette.cGray2
                      "
                      [iconWidth]="18"
                      [iconHeight]="18"></app-icon>
                  </div>

                  <button
                    *ngIf="questionForm.get('orientation')?.value === RadioListOrientation.Horizontal"
                    aria-label="delete-option-button"
                    type="button"
                    class="action-button action-button-horizontal"
                    mat-icon-button
                    [matTooltip]="'Delete option'"
                    matTooltipShowDelay="500"
                    (click)="removeOption(i)">
                    <app-icon [iconWidth]="16" [iconHeight]="16" [svg]="EIcon.MAT_DELETE_FOREVER"></app-icon>
                  </button>
                </div>

                <div class="display-flex align-items-center grid-gap-2">
                  <div
                    *ngIf="questionForm.get('orientation')?.value === RadioListOrientation.Horizontal"
                    class="custom-input-container display-flex align-items-center justify-content-center">
                    <input type="radio" class="custom-input" [value]="option.value" formControlName="defaultValue" />
                  </div>

                  <input
                    class="input checklist-label-input"
                    [value]="option.label"
                    (blur)="updateOptionLabel(i, $event)"
                    (keydown.enter)="
                      updateOptionLabel(i, $event); addOptionAfter(i); $event.preventDefault(); $event.stopPropagation()
                    "
                    [maxLength]="50"
                    (input)="updateOptionWidth($event, i)"
                    [placeholder]="optionPlaceholder"
                    [style.width]="optionWidths[i] ?? 'auto'" />
                  <span #optionLabelElement class="title-hidden"></span>

                  <button
                    *ngIf="questionForm.get('orientation')?.value !== RadioListOrientation.Horizontal"
                    aria-label="delete-option-button"
                    type="button"
                    class="action-button"
                    mat-icon-button
                    [matTooltip]="'Delete option'"
                    matTooltipShowDelay="500"
                    (click)="removeOption(i)">
                    <app-icon [iconWidth]="16" [iconHeight]="16" [svg]="EIcon.MAT_DELETE_FOREVER"></app-icon>
                  </button>
                </div>
              </div>

              <ng-template cdkDragPlaceholder>
                <div
                  class="question-placeholder"
                  [ngClass]="{
                    'question-placeholder-horizontal':
                      questionForm.get('orientation')?.value === RadioListOrientation.Horizontal
                  }"></div>
              </ng-template>
            </div>
          </div>

          <button
            class="display-flex align-items-center justify-content-center options-button options-button-add"
            (click)="addOption()"
            mat-button>
            <span class="display-flex align-items-center justify-content-center grid-gap-4 add-button">
              <app-icon
                [iconWidth]="20"
                [iconHeight]="20"
                [iconColor]="EColorPalette.cGray7"
                [svg]="EIcon.PLUS"></app-icon>
              <span>ITEM</span>
            </span>
          </button>

          <span
            class="display-flex align-items-center grid-gap-4"
            *ngIf="
              !isDefaultTempateType && questionItem?.defaultValue !== null && questionItem?.defaultValue !== undefined
            ">
            Show as:
            <a
              class="menu-trigger-text display-flex align-items-center grid-gap-4"
              [matMenuTriggerFor]="displayModeMenu"
              #menuTrigger="matMenuTrigger"
              (menuOpened)="onVarianceMenuOpened()"
              (menuClosed)="onVarianceMenuClosed()">
              {{ currentVarianceLabel ?? 'Default' }}
              <app-icon
                [iconColor]="EColorPalette.cGray4"
                [svg]="menuTrigger?.menuOpen ? EIcon.ANGLE_UP : EIcon.ANGLE_DOWN"
                [iconWidth]="8"
                [iconHeight]="8"></app-icon>
            </a>
          </span>
        </div>
      </ng-container>
    </div>
  </div>

  <div
    *ngIf="isEditingSetting && !!questionItem?.customFieldBinding && !isChoosingCustomFieldType"
    class="optional-content-container optional-content-container-comment">
    <div
      class="optional-content-settings-container small-custom-toggle display-flex align-items-center grid-gap-4"
      [formGroup]="questionForm">
      <span class="optional-content-settings-container-text">Required</span>
      <app-slide-toggle
        formControlName="isRequired"
        [containerCss]="'toggle-small'"
        [labelCss]="'body-small'"
        [disableRipple]="true"
        [activeBold]="false"></app-slide-toggle>
    </div>
    <a *ngIf="chooseCustomFieldName(questionItem) | async as name" (click)="openCustomFieldSelection()">
      On submission updates {{ name }}
    </a>
  </div>
</div>

<mat-menu #defaultValueMenu="matMenu" class="simple-mat-menu menu-with-backdrop">
  <button
    *ngIf="
      questionItem.defaultValue !== null && questionItem.defaultValue !== undefined && questionItem.defaultValue !== ''
    "
    mat-menu-item
    (click)="setDefault(questionItem, null)">
    Remove
  </button>

  <button mat-menu-item (click)="setDefault(questionItem, 'default')">Dynamic</button>

  <button *ngIf="questionItem?.type === 'boolean'" mat-menu-item (click)="setDefault(questionItem, true)">Yes</button>
  <button *ngIf="questionItem?.type === 'boolean'" mat-menu-item (click)="setDefault(questionItem, false)">No</button>

  <button *ngIf="questionItem?.type !== 'boolean'" mat-menu-item (click)="setDefault(questionItem)">
    Custom Value
  </button>
</mat-menu>

<mat-menu #orientationMenu="matMenu" class="simple-mat-menu menu-with-backdrop">
  <button *ngFor="let opt of orientationOptions" mat-menu-item (click)="setOrientation(opt.value)">
    {{ opt.label }}
  </button>
</mat-menu>

<mat-menu #displayModeMenu="matMenu" class="simple-mat-menu menu-with-backdrop">
  <button mat-menu-item *ngFor="let option of varianceOptions" (click)="onVarianceChange(option.id)">
    {{ option?.label }}
  </button>
</mat-menu>
